import { useEffect } from 'react';

const useSegmentTracking = (
  event: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props: { [key: string]: any },
  loading = false
): void => {
  useEffect(() => {
    if (!loading && window.analytics) {
      window.analytics.track(event, props);
    }
  }, [loading, event, props]);
};

export default useSegmentTracking;
